import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import '../styles/HeroSection.css';

const HeroSection = () => {
  const [ref, inView] = useInView({
    threshold: 0.1,
    triggerOnce: true
  });

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="hero" className="hero-section gradient-hero" ref={ref}>
      <div className="hero-background">
        <div className="hero-shapes">
          <div className="shape shape-1"></div>
          <div className="shape shape-2"></div>
          <div className="shape shape-3"></div>
        </div>
      </div>

      <div className="hero-container">
        <div className="hero-content">
          <motion.div 
            className="hero-text"
            initial={{ opacity: 0, y: 50 }}
            animate={inView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.8, delay: 0.2 }}
          >
            <motion.h1 
              className="hero-title"
              initial={{ opacity: 0, y: 30 }}
              animate={inView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.8, delay: 0.4 }}
            >
              Automatiza tu{' '}
              <span className="text-gradient">Atención al Cliente</span>
              {' '}con Inteligencia Artificial
            </motion.h1>

            <motion.p 
              className="hero-description"
              initial={{ opacity: 0, y: 30 }}
              animate={inView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.8, delay: 0.6 }}
            >
              Revoluciona tu negocio con Runamatic. Automatiza procesos de venta y atención al cliente en WhatsApp, Instagram, Facebook y más canales. Nuestra plataforma impulsada por IA convierte cada conversación en una oportunidad.
            </motion.p>

            <motion.div 
              className="hero-buttons"
              initial={{ opacity: 0, y: 30 }}
              animate={inView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.8, delay: 0.8 }}
            >
              <motion.button
                className="btn btn-primary btn-large"
                onClick={() => scrollToSection('demo')}
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
              >
                Ver Demo en Vivo
              </motion.button>
              
              <motion.button
                className="btn btn-outline btn-large"
                onClick={() => scrollToSection('plans')}
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
              >
                Explorar Planes
              </motion.button>
            </motion.div>

            <motion.div 
              className="hero-stats"
              initial={{ opacity: 0, y: 30 }}
              animate={inView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.8, delay: 1.0 }}
            >
              <div className="stat">
                <div className="stat-number">+500</div>
                <div className="stat-label">Empresas</div>
              </div>
              <div className="stat">
                <div className="stat-number">24/7</div>
                <div className="stat-label">Atención al cliente</div>
              </div>
            </motion.div>
          </motion.div>

          <motion.div 
            className="hero-visual"
            initial={{ opacity: 0, x: 50 }}
            animate={inView ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 0.8, delay: 0.5 }}
          >
            <motion.div 
              className="whatsapp-mockup"
              initial={{ opacity: 0, x: 100 }}
              animate={inView ? { opacity: 1, x: 0 } : {}}
              transition={{ duration: 2, delay: 0.3, ease: "easeOut" }}
            >
              <img 
                src="/mockups/WhatsAppMockup.svg" 
                alt="WhatsApp Mockup" 
                className="whatsapp-image"
              />
            </motion.div>

            <div className="floating-cards">
              <motion.div 
                className="floating-card"
                animate={{ y: [0, -10, 0] }}
                transition={{ duration: 3, repeat: Infinity, ease: "easeInOut" }}
              >
                <div className="card-indicator"></div>
                <div className="card-text">CRM Personalizado</div>
              </motion.div>
              
              <motion.div 
                className="floating-card"
                animate={{ y: [0, -15, 0] }}
                transition={{ duration: 4, repeat: Infinity, ease: "easeInOut", delay: 1 }}
              >
                <div className="card-indicator"></div>
                <div className="card-text">IA Conversacional</div>
              </motion.div>
              
              <motion.div 
                className="floating-card"
                animate={{ y: [0, -8, 0] }}
                transition={{ duration: 3.5, repeat: Infinity, ease: "easeInOut", delay: 2 }}
              >
                <div className="card-indicator"></div>
                <div className="card-text">Respuestas Instantáneas</div>
              </motion.div>
            </div>
          </motion.div>
        </div>
      </div>

      
    </section>
  );
};

export default HeroSection; 